import React from 'react';
import PropTypes from 'prop-types';

const padNum = (n) => String(n).padStart(2, '0');

const PillarsView = ({ data }) => {
  const eyebrow = data?.eyebrow || '';
  const title = data?.title || '';
  const variant = data?.variant || 'default';
  const columns = data?.columns || '3';
  const items = Array.isArray(data?.items) ? data.items : [];

  const cls = [
    'ag-pillars',
    `ag-pillars--${variant}`,
    `ag-pillars--cols-${columns}`,
  ].join(' ');

  return (
    <section className={cls}>
      <div className="ag-pillars__container">
        {(eyebrow || title) && (
          <header className="ag-pillars__header">
            {eyebrow && <div className="ag-pillars__eyebrow">{eyebrow}</div>}
            {title && <h2 className="ag-pillars__title">{title}</h2>}
          </header>
        )}
        {items.length > 0 && (
          <div className="ag-pillars__grid">
            {items.map((it, idx) => {
              const num = it?.num || padNum(idx + 1);
              const h3 = it?.title || '';
              const body = it?.body || '';
              return (
                <article className="ag-pillar" key={`pillar-${idx}`}>
                  <p className="ag-pillar__num" aria-hidden="true">
                    {num}
                  </p>
                  {h3 && <h3 className="ag-pillar__title">{h3}</h3>}
                  {body && <p className="ag-pillar__body">{body}</p>}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

PillarsView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.string,
    columns: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};

export default PillarsView;
